import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { cn } from "../../utils";
import { TableCell, TableRow } from "../table";
import { getFixedTableHeight } from "../utils/get-fixed-table-height";
import { TableEmptyFilters } from "./table-empty-filters";
import { TableEmptySearch } from "./table-empty-search";
import { TableEmptyWithoutFilters } from "./table-empty-without-filters";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TableEmptyResults = function TableEmptyResults(_ref) {
  var _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 9999 : _ref$columns,
    _ref$filtersAppliedCo = _ref.filtersAppliedCount,
    filtersAppliedCount = _ref$filtersAppliedCo === void 0 ? 0 : _ref$filtersAppliedCo,
    pageSize = _ref.pageSize,
    _ref$searchKey = _ref.searchKey,
    searchKey = _ref$searchKey === void 0 ? '' : _ref$searchKey,
    emptyTableText = _ref.emptyTableText,
    _ref$resetFilters = _ref.resetFilters,
    resetFilters = _ref$resetFilters === void 0 ? function () {} : _ref$resetFilters,
    icon = _ref.icon,
    children = _ref.children;
  return /*#__PURE__*/_jsx(TableRow, {
    className: "hover:tw-bg-inherit dark:hover:tw-bg-inherit",
    children: /*#__PURE__*/_jsxs(TableCell, {
      colSpan: columns,
      className: cn('tw-text-center', pageSize > 10 && 'tw-py-28'),
      style: {
        height: pageSize <= 10 ? getFixedTableHeight(pageSize) : 'auto'
      },
      children: [!searchKey && filtersAppliedCount === 0 && /*#__PURE__*/_jsx(TableEmptyWithoutFilters, _objectSpread(_objectSpread({}, emptyTableText), {}, {
        icon: icon,
        children: children
      })), searchKey.length > 0 && filtersAppliedCount === 0 && /*#__PURE__*/_jsx(TableEmptySearch, {
        searchKey: searchKey
      }), filtersAppliedCount > 0 && /*#__PURE__*/_jsx(TableEmptyFilters, {
        onFiltersReset: resetFilters
      })]
    })
  });
};